/* lua.js generated code 0.3.0 */

EnterGameURL = xClass("EnterGameURL", EventDispatcher)
EnterGameURLEvent = table([1, "EnterWithURL", "ENTERGAMEURLEVENT.ENTERWITHURL"])
var instance = null
EnterGameURL.getInstance = function () {
    var self = this
    if (!instance) {
        instance = EnterGameURL.create()
        instance.init()
    }
    return instance
}
EnterGameURL.prototype.ctor = function () {
    var self = this
    EventDispatcher.prototype.ctor.call(self)
    self.lastData = null
    self.lastSource = null
}
EnterGameURL.prototype.init = function () {
    var self = this
    self._redirector = {}
    self._cacheRedirector = sTable()

    self.registRedirector(require('clover/scene/component/homescene/InteractiveInvite/InteractiveInviteRedirector'));   // 互动邀请

    self.registRedirector(require('clover/redirect/MarkPriseWxChestClickRedirector')) // wx限时签到宝箱
    // self.registRedirector(require('clover/redirect/OpenCouponRedirector')) // 弹出兑换码面板
    self.registRedirector(require('activity/PvpActivity/FriendPvpRedirector')) //友谊赛邀请
    self.registRedirector(require('clover/redirect/Add5StepLinkRedirector')) // wx加五步链接
    self.registRedirector(require('activity/TreasureBox/TreasureBoxShareInRedirector')) // wx宝箱点击好友求助进入
    self.registRedirector(require('clover/redirect/ChallengeRedirector')) // wx宝箱点击好友求助进入
    self.registRedirector(require("clover/redirect/TimeModeActivityRedirector"))
    self.registRedirector(require("activity/CoinMatchActivity/CoinMatchRedirector"))
    self.registRedirector(require('clover/redirect/WxYiYuanGiftRedirector')) // wx一元礼包点连接进入
    self.registRedirector(require('activity/GoldMatchActivity/GoldMatchRedirector'))
    self.registRedirector(require('clover/redirect/StarDrawRedirector')) //星星抽奖大奖分享邀请
    // 摇一摇活动
    // self.registRedirector(require("activity/Gacha/GachaRedirector"))
    //限时礼包
    self.registRedirector(require("activity/TimeLimitGift/TimeLimitGiftRedirector"))
    //看攻略
    self.registRedirector(require("clover/redirect/StrategyRedirector"))
    
    self.registRedirector(require('clover/redirect/StarChestExtraRewardRedirector')) // 宝箱额外奖励
    
    self.registRedirector(require('clover/redirect/GoldMatchAddStepShareRedirector')) // 夺宝求助加步数
    
    self.registRedirector(require('clover/redirect/CashNotEnoughShareRedirector')) // 风车币不足

    self.registRedirector(require('clover/redirect/CoinNotEnoughShareRedirector')) // 银币不足
    
    self.registRedirector(require('clover/redirect/TimeModeShareRedirector')) // 限时挑战分享加时间

    self.registRedirector(require('clover/redirect/LevelBonusShareRedirector')) //  主线关双倍奖励分享

    // self.registRedirector(require("clover/scene/component/homescene/NewRank/NewRankRedirector"));   // 新排行榜跳转 

    self.registRedirector(require("clover/redirect/FailMainLevelGiftBagRedirector"));   //  关末分享礼包邀请

    self.registRedirector(require("clover/panel/unlock/UnlockIslandRedirector"));       //  岛屿解锁分享

    self.registRedirector(require("clover/scene/component/homescene/IslandBook/IslandFullRedirector"));       //  岛屿满星分享

    self.registRedirector(require('clover/redirect/SeasideStarShareRedirector')) // 海滨之星 分享

    self.registRedirector(require('clover/redirect/LightningRushRedirector')) // 限时闯关 分享

    self.registRedirector(require('activity/IosPaymentGuide/PaymentGuideRedirector')) // pc接力支付引导

    self.registRedirector(require('clover/redirect/QualifyRedirector')) // 晋级赛邀请组队

    self.registRedirector(require('clover/redirect/StarDreamRedirector')) // 星岛分享

    self.registRedirector(require('clover/redirect/WechatGiftRedirector')) // 微信礼包

    self.registRedirector(require('clover/redirect/DouyinRevisitRewardRedirector')) // 抖音复访奖励
    self.registRedirector(require('clover/redirect/DouyinPushCardRewardRedirector')) // 抖音推荐卡奖励
    self.registRedirector(require('clover/redirect/FishingRedirector')) // 钓鱼大赛分享鱼

    self.registRedirector(require('clover/redirect/PetStoryRedirector')) // 宠物邀请组队


}
// 获取本次进入时的URL 如果是直接切换进的 则会是nil
EnterGameURL.prototype.getLastData = function () {
    var self = this
    // FIXME: multi result
    return [clone(self.lastData), self.lastSource]
}
EnterGameURL.prototype.onEnterForeground = function () {
    var self = this
    self.lastData = null
    self.lastSource = null
}
EnterGameURL.prototype.cleanCache = function () {
    var self = this
    self.lastData = null
    self.lastSource = null
    self._cacheRedirector = sTable()
}
EnterGameURL.prototype.onEnterWithURL = function (url, shareTicket) { 
    var self = this
    let data = null;
    if (url && typeof url === 'object') {
        data = url
    } 
    // else {
    //     data = self.getParams()
    // }
    // data.handoff = "any"
    if (data) {
        console.info('onEnterWithURL', data)
        self.transformSpecialType(data)
        //屏蔽搜索进入
        IpRegionLimitManager.getInstance().checkEnterStatus(data)
        return self.procRedirector(data, undefined, shareTicket)
    } else {
        return Promise.resolve()
    }
}
EnterGameURL.prototype.transformSpecialType = function (data) {
    // 互动邀请
    if (data.shareMessageToFriendScene == ShareToFriendScene.InteractiveInvite) {
        data.type = 'interactiveInvite'
    } else if (data.shareMessageToFriendScene == ShareToFriendScene.UnlockIsland) {
        data.type = "island_unlock"
        data.subType = "islandunlock_share_openData"
    }
    // 之前未按规则写的Redirector
    else if (data.roomid) {
        if (data.isFriendPvp){
            data.type = 'friend_pvp'
        }else{
            data.type = 'pvp'
        }
    } else if (data.add5ShareId) {
        data.type = 'add5StepLink'
    } else if (data.treasureBox) {
        data.type = 'treasureBox'
    } else if (data.challengeLevelId) {
        data.type = 'challenge'
    }else if (data.oneStepShareId) {
        data.type = "oneStep"
    } else if(data.weekGameHelp) {
        data.type = "weekGameHelp"
    } else if (data.timeModeShareId) {
        data.type = "timeMode"
    } else if (data.timeLimitGift){
        data.type = "TimeLimitGift"
    } else if (data.handoff) {
        data.type = "handoffPaymentGuide"
    }
}
// EnterGameURL.prototype.onEnterWithUniversalLink = function (url) {
//     var self = this
//     if (type(url) === "string" && string.len(url) > 0) {
//         var data = self.parseLink(url)
//         if (data) {
//             self.procRedirector(data)
//         }
//     }
// }
EnterGameURL.prototype.procRedirector = function (data, source, shareTicket) {
    var self = this
    var redirector
    var platformRewardsRedirectors = []
    if (data.type) {
        redirector = self.getRedirector(data.type)
    }else{
        // 没有类型的可能是需要检查不同平台发放的礼包
        platformRewardsRedirectors.push(self.getRedirector('wechatGift'))
        platformRewardsRedirectors.push(self.getRedirector('douyinRevisitReward'))
        platformRewardsRedirectors.push(self.getRedirector('douyinPushCardReward'))
    }
    let result
    if (redirector) {
        var inst = redirector.create('', '', data, source, shareTicket)
        result = self.runRedirector(inst)
    }else if(platformRewardsRedirectors.length > 0){
        for (let i = 0; i < platformRewardsRedirectors.length; i++) {
            var rewardsRedirector = platformRewardsRedirectors[i]
            console.log("[tt] rewardsRedirector", rewardsRedirector)
            var inst = rewardsRedirector.create('', '', data, source, shareTicket)
            result = self.runRedirector(inst)
        }
    } else {
        result = Promise.resolve()
        cc.log("[############]unsupport, redirect url")
    }
    self.lastData = data
    self.lastSource = source
    return result
}
EnterGameURL.prototype.runRedirector = function (redirector) {
    let self = this
    let res = redirector.redirect()
    if (res instanceof Promise) {
        return res.then(() => {}, () => self.cacheRedirector(redirector))
    } else {
        if (!res) {
            self.cacheRedirector(redirector)
        }
        return Promise.resolve()
    }
}
// EnterGameURL.prototype.getParams = function (param) {
//     var self = this
//     var p = table()
//     var $st17 = string.gmatch(param, "([^&]+)=([^&]+)")
//     while (1) {
//         var t = $st17[0]($st17[1], $st17[2])
//         var k = t[0]
//         var v = t[1]
//         if (k == null) break
//         $st17[2] = k
//         p[k] = v
//     }
//     return p
// }
// EnterGameURL.prototype.getOpenUrlData = function () {
//     var __VA_ARG = $slice(arguments, 0)
//     var self = this
//     // WARN: maybe multi result
//     return clone(self.openUrlData)
// }
EnterGameURL.prototype.getParams = function (res) {

    if (window.mini) {
        if (!res)
        {
            res = mini.getLaunchOptionsSync()
        }
        console.log("@@@@get launch option:"+JSON.stringify(res))
        let query = res.query
        console.log("[tt] getParams query", query)
        if (mini.getPlatform() == MiniPlatform.tt){
            // 抖音的跳回游戏的来源
            if (!query){
                query = {}
            }
            console.log("[tt] getParams res.launch_from", res.launch_from)
            console.log("[tt] getParams res.location", res.location)
            console.log("[tt] getParams query.start_page", query.start_page)
            console.log("[tt] getParams query.card_id", query.card_id)
            query.tt_launch_from = res.launch_from; // 侧边栏复访用
            query.tt_location = res.location;       // 侧边栏复访用
            if (query.start_page && query.card_id){
                query.tt_start_page = query.start_page;   // 推荐卡用
                query.tt_card_id = query.card_id;         // 推荐卡用
            }
            
        }
        if (query && query.scene) {
            try {
                let scene = decodeURIComponent(query.scene) 
                let sceneRegex = /([^=#]+)=([^&#]*)/g
                let match
                while (match = sceneRegex.exec(scene)) {
                    query[match[1]] = match[2]
                }
                cc.log("after wx launch options", res)
            } catch (e) { }
        }
        if (mini.getPlatform() == MiniPlatform.wechatGame && query && query.channelId && query.channelId != ""){
            console.log("[ad] wechat channelId=" + query.channelId)
            // 媒体投放传来的渠道号，用来标记用户来源
            _G.__CHANNEL_ID = query.channelId
        }
        // 从其他小程序跳转过来，把extraData.data设置为type，兑换码使用extraData字段
        if (res.referrerInfo && res.referrerInfo.extraData) {
            let extraData = res.referrerInfo.extraData
            if (extraData.data) {
                query.type = extraData.data
            }
            query.extraData = extraData;
        }
        return query
    } else {
        var regex = /[?&]([^=#]+)=([^&#]*)/g,
            url = window.location.href,
            params = {},
            match;
        while (match = regex.exec(url)) {
            params[match[1]] = match[2];
        }
        return params
    }
}
// EnterGameURL.prototype.parseLink = function (url) {
//     var self = this
//     if (url && url !== "") {
//         var host = string.find(url, "%w/")
//         var page = string.find(url, "?")
//         if (!host || !page) {
//             return 
//         }
//         var [scheme, api] = ["", ""]
//         var p = url
//         if (host) {
//             scheme = string.sub(url, string.find(url, "://") + 3, host)
//             api = string.sub(url, host + 2, page - 1)
//             api = string.sub(api, (string.find(api, "/[%w%.]+$") || 0) + 1, (string.find(api, "%.%w+") || 0) - 1)
//             p = string.sub(url, page + 1)
//         }
//         var kvPairs = self.getParams(p)
//         var mod = kvPairs.method || ""
//         kvPairs.method = null
//         return table(
//             [1, "scheme", scheme],
//             [1, "method", mod],
//             [1, "api", api],
//             [1, "para", kvPairs]
//         )
//     }
// }
//--------------------------------------------------------------
// 游戏跳转注册
//--------------------------------------------------------------
// redirector Class extends clover.redirect.BaseRedirector
EnterGameURL.prototype.registRedirector = function (redirector) {
    var self = this
    if (redirector && redirector.prototype) {
        let name = redirector.prototype.getName()
        if (self._redirector[name]) {
            throw new Error(`found same name redirector ${name}`)
        } else {
            self._redirector[name] = redirector
        }
    }
}
EnterGameURL.prototype.getRedirector = function (moduleName) {
    var self = this
    return self._redirector[moduleName]
}
// redirector instance of clover.redirect.BaseRedirector
EnterGameURL.prototype.cacheRedirector = function (redirector) {
    var self = this
    table.insert(self._cacheRedirector, redirector)
}
EnterGameURL.prototype.handerRedirect = function () {
    var self = this
    var list = self._cacheRedirector
    self._cacheRedirector = sTable()
    let promise = Promise.resolve()
    for (let i = 1, v = list[1]; v; i++, v = list[i]) {
        promise = promise.then(() => self.runRedirector(v))
    }
    return promise
}
EnterGameURL.prototype.isRedirectorInCacheHasHighPriorityAction = function () {
    var self = this
    for (var i = 1, v = self._cacheRedirector[1]; v; i++, v = self._cacheRedirector[i]) {
        if (v.hasHighPriorityAction()) {
            return true
        }
    }
    return false
}
EnterGameURL.prototype.getCachedRedirectorsByName = function (name) {
    var self = this
    var ret = sTable()
    for (var i = 1, v = self._cacheRedirector[1]; v; i++, v = self._cacheRedirector[i]) {
        if (v.getName() === name) {
            table.insert(ret, v)
        }
    }
    return ret
}

EnterGameURL.prototype.popCachedRedirectorsByName = function (name) {
    var self = this
    for (var i = 1, v = self._cacheRedirector[1]; v; i++, v = self._cacheRedirector[i]) {
        if (v.getName() === name) {
            let item = v;
            table.remove(self._cacheRedirector, i);
            return item;
        }
    }
    return null;
}
//---------------------------------------------------------------